import { schema } from 'normalizr';
import { Base64 } from '../../../util/Base64';
import { GroupAPIResponse } from './group.model';

export const groupsSchema = new schema.Entity(
  'groups',
  {},
  {
    idAttribute: (value: GroupAPIResponse) => Base64.decode(value.id),
    processStrategy: (
      value: GroupAPIResponse,
      parent: NormalizedGroup,
      key
    ) => {
      const parentGroupId = parent?.id;
      const id = Base64.decode(value.id);
      const deepLevel = (parent.deepLevel || 0) + 1;
      const pathGroupsIds: string[] = parent?.pathGroupsIds
        ? parent?.pathGroupsIds.slice()
        : [];
      pathGroupsIds.push(id);

      return {
        ...value,
        parentGroupId,
        devices: value?.devices?.map((device) => Base64.decode(device)) ?? [],
        childGroups: value?.childGroups ?? [],
        users: value?.users?.map((user) => Base64.decode(user)) ?? [],
        attributes: value?.attributes ?? {},
        deepLevel,
        pathGroupsIds,
        id,
      };
    },
  }
);

groupsSchema.define({
  childGroups: [groupsSchema],
});

export type NormalizedGroup = Omit<GroupAPIResponse, 'childGroups'> & {
  childGroups: string[];
  parentGroupId?: string;
  pathGroupsIds: string[];
  devices: string[];
  users: string[];
  deepLevel: number;
};
export interface GroupStructure {
  entities: {
    groups: Record<string, NormalizedGroup>;
  };
  result: string[];
}

export const groupsListSchema = new schema.Array(groupsSchema);
